import { useState, useEffect } from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Choice, SingleChoiceQuestionProps } from './_props'
import useStyles from './_styles'

export default function SingleChoiceQuestion({
    question,
    initialValue = null,
    onAnswer,
    onNext,
    onSkip,
}: SingleChoiceQuestionProps) {
    const classes = useStyles()
    const [selected, setSelected] = useState<string | null>(null)

    useEffect(() => {
        setSelected(initialValue ?? null)
    }, [question.id, initialValue])

    const handleSelect = (choice: Choice) => {
        const newSelected = selected === choice.id ? null : choice.id
        setSelected(newSelected)
        onAnswer?.(newSelected ? choice : null)
    }

    return (
        <section className={classes.section}>
            <div className={classes.choicesContainer}>
                {question.choices.map((c) => (
                    <button
                        key={c.id}
                        onClick={() => handleSelect(c)}
                        aria-pressed={selected === c.id}
                        className={`${classes.choiceButton} ${selected === c.id ? 'selected' : ''}`}
                    >
                        {c.label}
                        {selected === c.id && <CheckCircleIcon className={classes.checkIcon} />}
                    </button>
                ))}
            </div>
        </section>
    )
}
